export default "__VITE_ASSET__CtAd5YFI__"